import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VariablesService } from './variables.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private idCentroComercial:number = environment.idCentroComercial;
  private centroComercial:string = environment.centroComercial;
  constructor(private http:HttpClient,
              private variableService:VariablesService
  ) { }

  getByDocument(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getByDocument;
    return this.http.post(url,body);
  }

  saveEntradaVisitantes(body:any){    
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    body.usuario  = this.variableService.usuario;
    const url = environment.client.base + environment.client.endpoints.saveEntradaVisitantes;
    return this.http.post(url,body);
  }

  getCanalAtencion(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getCanalAtencion;
    return this.http.post(url,body);
  }

  getTipoFpqrs(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getTipoFpqrs;
    return this.http.post(url,body);
  }

  getCategoriaFpqrs(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getCategoriaFpqrs;
    return this.http.post(url,body);
  }

  getArea(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getArea;
    return this.http.post(url,body);
  }

  getTipoDocumento(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getTipoDocumento;
    return this.http.post(url,body);
  }

  getCiudad(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getCiudad;
    return this.http.post(url,body);
  }

  getBarrio(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getBarrio;
    return this.http.post(url,body);
  }

  getMotivoSolicitud(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getMotivoSolicitud;
    return this.http.post(url,body);
  }

  insertOrEditFpqrs(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.insertOrEditFpqrs;
    return this.http.post(url,body);
  }

  getFpqrs(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getFpqrs;
    return this.http.post(url,body);
  }

  getFilesFpqrs(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getFilesFpqrs;
    return this.http.post(url,body);
  }

  getReferencias(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getReferencias;
    return this.http.post(url,body);
  }

  listTiposReferencia(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.listTiposReferencia;
    return this.http.post(url,body);
  }

  listReferenciasPorTipo(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.listReferenciasPorTipo;
    return this.http.post(url,body);
  }

  insertOrEditReferencia(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    body.usuario = this.variableService.usuario;
    const url = environment.client.base + environment.client.endpoints.insertOrEditReferencia;
    return this.http.post(url,body);
  }

  insertOrEditClient(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.insertOrEditClient;
    return this.http.post(url,body);
  }

  getClient(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getClient;
    return this.http.post(url,body);
  }

  // Trae UN cliente completo (incluye firma escaneada) — usar solo al abrir la
  // ficha para editar, no para listar/buscar (ver getClient).
  getClienteDetalle(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getClienteDetalle;
    return this.http.post(url,body);
  }

  // Público — se llama desde /desuscribir sin que el usuario esté logueado.
  desuscribir(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.desuscribir;
    return this.http.post(url,body);
  }

  // Módulo Lista Negra: clientes con SUSCRITO = 'N'.
  listNoSuscritos(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.listNoSuscritos;
    return this.http.post(url,body);
  }

  resuscribirCliente(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.resuscribirCliente;
    return this.http.post(url,body);
  }

  getComercial(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getComercial;
    return this.http.post(url,body);
  }

  getPiso(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getPiso;
    return this.http.post(url,body);
  }

  getPlazoleta(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getPlazoleta;
    return this.http.post(url,body);
  }

  getTipoStand(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.getTipoStand;
    return this.http.post(url,body);
  }

  insertOrEditStand(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.insertOrEditStand;
    return this.http.post(url,body);
  }

  insertOrEditQuoteComercial(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.insertOrEditQuoteComercial;
    return this.http.post(url,body);
  }

  asambleaFirma(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.asambleaFirma;
    return this.http.post(url,body);
  }

  searchAsambleistas(body:any){
    body.centroComercial = this.centroComercial;
    body.idCentroComercial = this.idCentroComercial;
    const url = environment.client.base + environment.client.endpoints.searchAsambleistas;
    return this.http.post(url,body);
  }

}
